import 'react-clock/dist/Clock.css';

import TimePicker from './TimePicker';

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
import './TimePicker.css';

export default TimePicker;
